import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const imgUrl = (u) => (u && u.startsWith("/api") ? `${BACKEND_URL}${u}` : u);

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-NZ", { day: "numeric", month: "long", year: "numeric" }) : "";

export const errMsg = (e) => e?.response?.data?.detail?.toString?.() || e?.message || "Something went wrong";
